import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import axios from "axios";
import { useHistory } from "react-router-dom";
import {
  setUserSessionAuthKey,
  previewPdf
} from "../../../Component/commonUtils";
import TranslationFile from "../../15-Translation/locale/Translation_apps.json";
import Joyride from "react-joyride";
import { ProgressSpinner } from "primereact/progressspinner";
import { Tooltip } from "primereact/tooltip";
import ExternalNavBarHeader from "../ExternalNavBarHeader/ExternalNavBarHeader";
import Externalvalidation from "../Externalvalidation";

let unPaidReportsArray = [];

const getExternalUser = () => {
  try {
    return JSON.parse(localStorage.getItem("RBLExternalUserDetails") || "null");
  } catch (err) {
    return null;
  }
};

const createDefaultFilters = () => ({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  companyName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
  },
  registrationNo: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
  },
  financialYear: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
  },
  createdAtDateTime: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
  },
  createdBy: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
  },
  modifiedAtDateTime: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }]
  },
  reportStatusText: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }]
  }
});

export default function ExternalDashboard() {
  const userSelectedLanguage = localStorage.getItem("selectedLanguage");
  const history = useHistory();

  // Only the PDF button is left to explain (no toggle / company link / link share)
  const steps = [
    {
      content: TranslationFile.TourGuide_PDF_Btn[userSelectedLanguage],
      placement: "top",
      styles: { options: { width: 300 } },
      target: ".dashboard-pdf-Id",
      title: "Pdf",
      disableBeacon: true
    }
  ];

  const currentPageTourGuideName = "Dashboard";

  const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [dashboardAPIResponse, setDashboardAPIResponse] = useState([]);
  const [run, setRun] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [gridLoading, setGridLoading] = useState(true);
  const [filters, setFilters] = useState(createDefaultFilters());

  const toast = useRef(null);
  const dt = useRef(null);

  const statuses = [
    TranslationFile.Draft[userSelectedLanguage],
    TranslationFile.SenttoBolagsverket[userSelectedLanguage],
    TranslationFile.ActionRequired[userSelectedLanguage],
    TranslationFile.Registered[userSelectedLanguage],
    TranslationFile["Closed(NotRegistered)"][userSelectedLanguage],
    TranslationFile.TechnicalError[userSelectedLanguage]
  ];

  let userSessionAuthKeyReturnValue = setUserSessionAuthKey();

  const handleEmptyValues = (respData) => {
    const keysToCheck = [
      "registrationNo",
      "createdAtDateTime",
      "createdBy",
      "modifiedAtDateTime"
    ];
    return respData.map((item) => {
      keysToCheck.forEach((key) => {
        if (item[key] === "" || item[key] === null) {
          item[key] = "-";
        }
      });
      item.reportStatusText =
        TranslationFile[item.reportStatus.replace(/\s/g, "")][
          userSelectedLanguage
        ];
      return item;
    });
  };

  const processResponse = (data) => {
    let respData = Array.isArray(data) ? data : [];
    respData.forEach((i) => {
      if (i.createdAtDateTime > i.modifiedAtDateTime) {
        i.modifiedAtDateTime = "";
      }
    });
    respData = respData.reverse();
    return handleEmptyValues(respData);
  };

  /*   const loadReports = () => {
    const authConfig = userSessionAuthKeyReturnValue;
    if (!authConfig) 
      
      return Promise.resolve();
    
    setGridLoading(true);
    return axios
      .get("/userDashboard/getLinkSharedDetails", userSessionAuthKeyReturnValue)
      .then((response) => {
        setDashboardAPIResponse(processResponse(response.data));
        setGridLoading(false);
      })
      .catch(() => {
        setGridLoading(false);
      });
  }; */
  const loadReports = async () => {
    const externalUser = getExternalUser();
    const authConfig = setUserSessionAuthKey();

    if (!authConfig || !externalUser) {
      setGridLoading(false);
      return;
    }

    setGridLoading(true);
    try {
      const response = await axios.get(
        "/userDashboard/getLinkSharedDetails",
        authConfig
      );
      setDashboardAPIResponse(processResponse(response.data));
    } catch (err) {
      setDashboardAPIResponse([]);
    } finally {
      setGridLoading(false);
    }
  };

  useEffect(() => {
    const isValid = Externalvalidation();
    if (!isValid) {
      history.replace("/external/*");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("currentPageName", "Dashboard");
    window.scrollTo(0, 0);

    loadReports();

    const timer = setTimeout(() => {
      const userTourGuide =
        JSON.parse(localStorage.getItem("TourGuide")) || false;
      setRun(userTourGuide);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const userTourGuide =
      JSON.parse(localStorage.getItem("TourGuide")) || false;
    const tourGuidePages =
      JSON.parse(localStorage.getItem("tourGuidePages")) || [];

    if (userTourGuide) {
      if (tourGuidePages.includes(currentPageTourGuideName)) {
        setTimeout(() => setRun(false), 200);
      } else {
        setTimeout(() => setRun(true), 200);
      }
    }

    if (!tourGuidePages.includes(currentPageTourGuideName)) {
      tourGuidePages.push(currentPageTourGuideName);
      localStorage.setItem("tourGuidePages", JSON.stringify(tourGuidePages));
    }
  }, [currentPageTourGuideName]);

  const reportStatusColourCode = (status) => {
    switch (status) {
      case "Sent to Bolagsverket":
      case "Skickat till Bolagsverket":
        return ["#2196F3", "#ffffff"];
      case "Action Required":
      case "Åtgärd krävs":
        return ["#efff009e", "#000000"];
      case "Registered":
      case "Registrerad":
        return ["#689F38", "#ffffff"];
      case "Closed (Not Registered)":
      case "Avslutad (Ej registrerad)":
        return ["#80808038", "#000000"];
      case "Technical Error":
      case "Tekniskt fel":
        return ["#D32F2F", "#ffffff"];
      case "Draft":
      case "Utkast":
        return ["#FBC02D", "#ffffff"];
      default:
        return ["#cccccc", "#000000"];
    }
  };

  const hideDeleteProductsDialog = () => setDeleteProductsDialog(false);

  const confirmDeleteSelected = () => {
    const paidReportArray = [];
    selectedProducts &&
      selectedProducts.forEach((val) => {
        if (val.paymentEntryNo > 0) {
          paidReportArray.push(val);
        } else {
          unPaidReportsArray.push(val);
        }
        unPaidReportsArray = [...new Set(unPaidReportsArray)];
      });
    if (paidReportArray.length > 0) {
      toast.current.show({
        severity: "error",
        summary: "No Delete Applicable",
        detail:
          "The Paid Report cannot be deleted. Please uncheck and Try Again",
        life: 3000
      });
    } else {
      setDeleteProductsDialog(true);
    }
  };

  const deleteSelectedProducts = () => {
    const authConfig = userSessionAuthKeyReturnValue;
    if (!authConfig || !selectedProducts || !selectedProducts.length) return;

    const reportIds = selectedProducts.map((i) => i.reportId).join(",");

    setGridLoading(true);
    axios
      .get("/annualReport/hideReportHeaders?reportIds=" + reportIds, authConfig)
      .then(() => loadReports());

    setDeleteProductsDialog(false);
    setSelectedProducts(null);
    toast.current.show({
      severity: "success",
      summary: TranslationFile.SuccessfulText[userSelectedLanguage],
      detail: TranslationFile.ReportDeletedSuces[userSelectedLanguage],
      life: 3000
    });
  };

  const clearFilter = () => setFilters(createDefaultFilters());

  const isAnyFilterApplied = () =>
    Object.keys(filters).some(
      (heading) =>
        heading != "global" &&
        filters[heading].constraints != undefined &&
        filters[heading].constraints[0].value != null
    );

  const onGlobalFilterChange = (e) => {
    const val = e.target.value;
    const _filters = { ...filters };
    _filters["global"].value = val;
    setFilters(_filters);
    setGlobalFilter(val);
  };

  const leftToolbarTemplate = () => (
    <div className="AnnualReport-LeftToolbarTemplate">
      <Button
        className="whole-delete"
        label={TranslationFile.dashboardDeleteBtn[userSelectedLanguage]}
        icon="pi pi-trash"
        severity="danger"
        onClick={confirmDeleteSelected}
        disabled={!selectedProducts || !selectedProducts.length}
      />
      &nbsp;
      {isAnyFilterApplied() && (
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label={
            TranslationFile.dashboardClearFilterBtnLbl[userSelectedLanguage]
          }
          outlined
          onClick={clearFilter}
        />
      )}
    </div>
  );

  const header = () => (
    <div className="Toolbar-center">
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onChange={onGlobalFilterChange}
          placeholder={TranslationFile.dashboardSearchBtn[userSelectedLanguage]}
          className="dashboard-search-bar"
        />
      </span>
    </div>
  );

  // Company name: plain text, not clickable
  const companyNameBodyTemplate = (rowData) => (
    <span className="dashboard-companyName">
      {rowData.companyName && rowData.companyName !== ""
        ? rowData.companyName
        : "-"}
    </span>
  );

  const registrationBodyTemplate = (rowData) => {
    let financialYear1 = ["-"];
    if (rowData.financialYear != null && rowData.financialYear !== "") {
      financialYear1 = rowData.financialYear.split(" ");
    }
    return (
      <div>
        <span> {financialYear1[0]}</span>
        <span style={{ fontWeight: "600" }}> {financialYear1[1]}</span>
        <span> {financialYear1[2]}</span>
      </div>
    );
  };

  const statusBodyTemplate = (rowData) => {
    const key = rowData.reportStatus.replace(/\s/g, "");
    const status = TranslationFile[key][userSelectedLanguage];
    const colourCodes = reportStatusColourCode(rowData.reportStatus);
    return (
      <>
        <Tooltip
          target=".status-tag"
          className="dashbaord-reportStatus-tooltip"
        />
        <Tag
          value={status}
          style={{
            backgroundColor: colourCodes[0],
            color: colourCodes[1],
            width: "min-content",
            cursor: "pointer"
          }}
          data-pr-tooltip={
            TranslationFile[key + "Tooltip"][userSelectedLanguage]
          }
          className="status-tag"
        ></Tag>
      </>
    );
  };

  const statusItemTemplate = (option) => {
    const colourCodes = reportStatusColourCode(option);
    return (
      <Tag
        value={option}
        style={{
          backgroundColor: colourCodes[0],
          color: colourCodes[1],
          width: "min-content",
          cursor: "pointer"
        }}
      ></Tag>
    );
  };

  const statusFilterTemplate = (opts) => (
    <div className="TEST">
      <Dropdown
        value={opts.value}
        options={statuses}
        onChange={(e) => opts.filterCallback(e.value, opts.index)}
        itemTemplate={statusItemTemplate}
        placeholder={TranslationFile.dashboardSelectOne[userSelectedLanguage]}
        className="dashboard-status-filter"
        showClear
        filter={false}
      />
    </div>
  );

  const previewPdfLocal = (reportGUID) => {
    setPdfLoading(true);
    setTimeout(() => {
      const pdfReturn = previewPdf(reportGUID);
      setPdfLoading(!pdfReturn);
    }, 500);
  };

  const pdfBodyTemplate = (rowData) => (
    <React.Fragment>
      <Button
        type="button"
        icon="pi pi-file-pdf"
        rounded
        outlined
        tooltip="PDF"
        className="dashboard-pdf-Id"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => previewPdfLocal(rowData.reportGUID)}
      />
    </React.Fragment>
  );

  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label={TranslationFile.noBtn[userSelectedLanguage]}
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label={TranslationFile.yesBtn[userSelectedLanguage]}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  const emptyMessageBodyTemplate = () => {
    if (isAnyFilterApplied()) {
      return (
        <div>
          {TranslationFile.dashboardNoFataFoundForFilter[userSelectedLanguage]}
        </div>
      );
    }
    return (
      <div>
        {TranslationFile.dashboardNoReport[userSelectedLanguage]} <br></br>
      </div>
    );
  };

  const loadingIconTemplate = () => (
    <ProgressSpinner
      style={{ width: "50px", height: "50px" }}
      strokeWidth="8"
      fill="var(--surface-ground)"
      animationDuration=".5s"
    />
  );

  const headerfunc = header();

  return (
    <div>
      <ExternalNavBarHeader />
      <div>
        <Joyride
          continuous
          run={run}
          disableBeacon={true}
          showProgress={false}
          showSkipButton
          steps={steps}
          scrollToFirstStep
          scrollToSteps
          scrollOffset={100}
          styles={{ options: { zIndex: 10000 } }}
        />

        <Toast ref={toast} position="top-right" className="toast-top" />

        <div
          className="myDashboardGridSideBarClose"
          style={{ marginLeft: 0, width: "100%" }}
        >
          <div className="dashboardGridMainDiv">
            <Toolbar
              className="dashboard-toolbar mb-4"
              left={leftToolbarTemplate}
              center={header}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={dashboardAPIResponse}
              editMode="cell"
              selection={selectedProducts}
              onSelectionChange={(e) => setSelectedProducts(e.value)}
              selectionMode="checkbox"
              dataKey="id"
              paginator
              rows={10}
              responsiveLayout="stack"
              breakpoint="768px"
              emptyMessage={emptyMessageBodyTemplate}
              currentPageReportTemplate={
                TranslationFile.showing[userSelectedLanguage] +
                "{first}" +
                TranslationFile.to[userSelectedLanguage] +
                "{last}" +
                TranslationFile.of[userSelectedLanguage] +
                "{totalRecords} " +
                TranslationFile.entries[userSelectedLanguage]
              }
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rowsPerPageOptions={[5, 10, 25, 50]}
              globalFilter={globalFilter}
              header={headerfunc}
              selectionPageOnly
              className="dashboard-datatable1"
              style={{ padding: "0rem" }}
              filters={filters}
              onFilter={(e) => setFilters(e.filters)}
              loading={gridLoading}
              loadingIcon={loadingIconTemplate}
              pt={{
                row: { className: "mobile-stack-row" },
                bodyCell: { className: "mobile-stack-cell" }
              }}
            >
              <Column
                selectionMode="multiple"
                exportable={false}
                className="dashboard-checkbox"
                style={{ padding: "1rem" }}
              ></Column>

              {/* Company Name - non clickable */}
              <Column
                field="companyName"
                header={
                  TranslationFile.dashboardCompanyName[userSelectedLanguage]
                }
                body={companyNameBodyTemplate}
                filter
                className="dashboard-company-name"
                style={{ padding: "1rem", width: "15%" }}
                filterMatchMode="contains"
                showFilterMatchModes={false}
                showFilterMenuOptions={false}
                filterPlaceholder={
                  TranslationFile.dashboardSearchBtn[userSelectedLanguage]
                }
              ></Column>

              {/* Organization Number */}
              <Column
                field="registrationNo"
                header={
                  TranslationFile.dashboardOrgNumber[userSelectedLanguage]
                }
                className="dashboard-org-no"
                filter
                style={{ padding: "1rem", width: "9%" }}
                filterMatchMode="contains"
                showFilterMenuOptions={false}
                filterPlaceholder={
                  TranslationFile.dashboardSearchBtn[userSelectedLanguage]
                }
              ></Column>

              {/* Financial Year */}
              <Column
                field="financialYear"
                body={registrationBodyTemplate}
                header={TranslationFile.dashboardFinYear[userSelectedLanguage]}
                className="dashboard-financial-year"
                filter
                style={{ padding: "1rem", width: "14%" }}
                filterMatchMode="contains"
                showFilterMenuOptions={false}
                filterPlaceholder={
                  TranslationFile.dashboardSearchBtn[userSelectedLanguage]
                }
              ></Column>

              {/* Created On */}
              <Column
                field="createdAtDateTime"
                header={
                  TranslationFile.dashboardCreatedOn[userSelectedLanguage]
                }
                filter
                className="dashboard-created-on"
                style={{ paddingLeft: "1rem" }}
                filterMatchMode="contains"
                showFilterMenuOptions={false}
                filterPlaceholder={
                  TranslationFile.dashboardSearchBtn[userSelectedLanguage]
                }
              ></Column>

              {/* Created By */}
              <Column
                field="createdBy"
                header={
                  TranslationFile.dashboardCreatedBy[userSelectedLanguage]
                }
                className="dashboard-created-by"
                filter
                style={{ paddingLeft: "1rem" }}
                filterMatchMode="contains"
                showFilterMenuOptions={false}
                filterPlaceholder={
                  TranslationFile.dashboardSearchBtn[userSelectedLanguage]
                }
              ></Column>

              {/* Modified On */}
              <Column
                field="modifiedAtDateTime"
                header={
                  TranslationFile.dashboardModifiedOn[userSelectedLanguage]
                }
                filter
                className="dashboard-modified-on"
                style={{ paddingLeft: "1rem" }}
                filterMatchMode="contains"
                showFilterMenuOptions={false}
                filterPlaceholder={
                  TranslationFile.dashboardSearchBtn[userSelectedLanguage]
                }
              ></Column>

              {/* Status */}
              <Column
                field="reportStatusText"
                header={
                  TranslationFile.dashboardStatusBtn[userSelectedLanguage]
                }
                body={statusBodyTemplate}
                filter
                filterElement={statusFilterTemplate}
                className="dashboard-status"
                style={{ paddingLeft: "1rem" }}
                filterMatchMode="contains"
                showFilterMenuOptions={false}
                filterPlaceholder={
                  TranslationFile.dashboardSearchBtn[userSelectedLanguage]
                }
              ></Column>

              {/* PDF */}
              <Column
                body={pdfBodyTemplate}
                exportable={false}
                className="dashboard-pdf"
                header="PDF"
                title="Download PDF"
                style={{ paddingLeft: "0.5rem" }}
                filterMatchMode="contains"
                showFilterMenuOptions={false}
              ></Column>
            </DataTable>
          </div>
        </div>

        <Dialog
          blockScroll
          visible={deleteProductsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header={TranslationFile.dashboardConfirmBtn[userSelectedLanguage]}
          modal
          footer={deleteProductsDialogFooter}
          onHide={hideDeleteProductsDialog}
        >
          <div className="confirmation-content">
            <div>
              <span>
                {TranslationFile.dashboardDeleteText[userSelectedLanguage]}
              </span>
            </div>
          </div>
        </Dialog>
      </div>

      <Dialog
        visible={pdfLoading}
        style={{ width: "30vw" }}
        className="pdfDialogBox"
        blockScroll
        closable={false}
      >
        <div className="pdfLoading">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem" }}></i>
        </div>
      </Dialog>
    </div>
  );
}
